import { Outlet } from "react-router-dom";
import { SidebarChromeProvider } from "../containers/Sidebar/SidebarChrome";

/**
 * The authenticated app shell.
 *
 * Everything a signed-in user sees renders inside this route. React Router
 * keeps a layout element mounted while only the `<Outlet />` beneath it swaps,
 * which is exactly the property the navigation panel needs: it is built once
 * per session instead of once per page view.
 *
 * Public screens (login, signup, password reset, the invitation landing) must
 * stay OUTSIDE this route group — they have no navigation, and mounting the
 * panel there would put a fleet menu on the login page.
 */
export const AppLayout: React.FC = () => (
  <SidebarChromeProvider>
    <Outlet />
  </SidebarChromeProvider>
);

export default AppLayout;
